import { Outlet } from "react-router-dom";

function Locations() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Locations;
